import React, { useState, useCallback } from 'react';

type AddUserModalProps = {
    isOpen: boolean;
    roleLabel: string;
    onClose: () => void;
    onSubmit: (email: string) => Promise<void>;
};

const AddUserModal: React.FC<AddUserModalProps> = ({ isOpen, roleLabel, onClose, onSubmit }) => {
    const [emailInput, setEmailInput] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleClose = useCallback(() => {
        setEmailInput('');
        onClose();
    }, [onClose]);

    const handleSubmit = useCallback(async (e: React.FormEvent) => {
        e.preventDefault();
        if (!emailInput.trim() || isSubmitting) { return; }

        setIsSubmitting(true);
        try {
            await onSubmit(emailInput.trim());
            setEmailInput('');
            onClose();
        } finally {
            setIsSubmitting(false);
        }
    }, [emailInput, isSubmitting, onSubmit, onClose]);

    if (!isOpen) { return null; }

    return (
        <>
            <div className="ModalOverlay active" onClick={handleClose}></div>
            <div className="AddUser Modal active" onClick={(e) => e.stopPropagation()}>
                <div className="ModalContent">
                    <div className="ModalHeader">
                        <h2 className="ModalTitle">{roleLabel} 추가하기</h2>
                    </div>
                    <div className="ModalBody">
                        <div className="QuestionSection">
                            <p className="QuestionDescription">추가할 {roleLabel} 정보 입력</p>
                            <div className="InputGroup">
                                <div className="InputLabel">
                                    <span className="LabelText">이메일 입력</span>
                                    <span className="RequiredMark">*</span>
                                </div>
                                <div className="InputBox">
                                    <input
                                        type="email"
                                        className="EmailInput"
                                        placeholder="여기에 이메일을 입력해주세요."
                                        value={emailInput}
                                        onChange={(e) => setEmailInput(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ModalFooter">
                        <button className="ModalButton TertiaryButton" onClick={handleClose}>닫기</button>
                        <button className="ModalButton SecondaryButton" onClick={handleSubmit} disabled={isSubmitting}>
                            {isSubmitting ? '처리 중...' : `${roleLabel} 추가하기`}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddUserModal;
